// const CryptoJS = require('crypto-js');
import CryptoJS from 'crypto-js';
export async function createSignature(secret, rmNumber, txnID, mId) {
  try {
    // let sec = secret;
    // let rmn = rmNumber;
    // let txnId = txnID;
    // let mid = mId;
    // let data = rmn + txnId + mid;
    // const hmac = crypto.createHmac("sha512", sec);
    // hmac.update(data);
    // let signature =  hmac.digest('hex');
    // console.log("Signature", signature);
    let sec = secret;
    let rmn = rmNumber;
    let txnId = txnID;
    let mid = mId;
    let data = rmn + txnId + mid;
    const hmac = CryptoJS.HmacSHA512(data, sec);
    let signature = hmac.toString(CryptoJS.enc.Hex);
    console.log('Signature:', signature);
    return signature;
  } catch (err) {
    console.log(err);
  }
}
export async function createServerSignature(secret, txnID, mId) {
  try {
    let sec = secret;
    let txnId = txnID;
    let mid = mId;
    let data = txnId + mid;
    const hmac = CryptoJS.HmacSHA512(data, sec);
    let signature = hmac.toString(CryptoJS.enc.Hex);
    console.log('Server Signature:', signature);
    return signature;
  } catch (err) {
    console.log(err);
  }
}
// const sign = await createSignature("468bb275e7d04a67b77aedf585c42772","8529637410","123456","022");
// console.log("sign:",sign);
